/**
 * Amber banner permanently pinned above the top bar. Reminds the user the
 * data on screen reflects dev-environment Vespa behavior and is not suitable
 * for ship-level decisions. Deliberately not dismissable (the data quality
 * mismatch is structural — no amount of acknowledgement fixes it).
 */
export function DevBanner() {
  return (
    <div
      style={{
        height: 28,
        background: "color-mix(in oklch, var(--warn) 35%, white)",
        color: "var(--warn-foreground)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        fontSize: 12,
        fontWeight: 500,
        borderBottom: "1px solid color-mix(in oklch, var(--warn) 60%, transparent)",
        fontFamily: "var(--font-sans)",
        flexShrink: 0,
      }}
    >
      <span
        style={{
          width: 6,
          height: 6,
          borderRadius: 99,
          background: "var(--warn-foreground)",
          opacity: 0.6,
        }}
      />
      Arena data reflects <b style={{ fontWeight: 600 }}>dev-environment</b> Vespa behavior. Ship
      decisions require prod validation.
    </div>
  );
}
